import { ConfigurationService } from '../services/configuration.service';
import { HtmlTextParser } from './html-text-parser.helper';

export default class DepartureBoardLinkHelper {
  public static generateLink(stopAreaGid1: string | undefined, stopAreaGid2: string | undefined, source: string): string {
    const params = new URLSearchParams();
    params.append('source', source);
    if (stopAreaGid1 !== undefined) {
      params.append('stopAreaGid', stopAreaGid1);
    }
    if (stopAreaGid2 !== undefined) {
      params.append('stopAreaGid', stopAreaGid2);
    }
    const baseUrl = ConfigurationService.get('departureBoardLinkGeneratorBaseUrl');
    if (!baseUrl) {
      throw new Error('Missing configuration for departureBoardLinkGeneratorBaseUrl');
    }
    return `${HtmlTextParser.decodeHtmlEntity(baseUrl)}?${params.toString()}`;
  }
}
